import React from 'react'
import styles from './statistics.module.css'
import calender from "../assets/calender.jpg"
import stars from "../assets/stars.jpg"

const Statistics = () => {
  return (
    
    <div className="flex flex-col p-4 justify-center max-w-screen-lg mx-auto h-full">
      <div className="pb-8">
        <div className={styles.stateHading}>
        <p className="text-4xl font-bold inline border-b-4 border-gray-500" style={{color:"white"}}>
        Statistics
        </p>
        </div>
        <div style={{padding:"1rem",boxSizing:"border-box"}}>
        <p>&nbsp;<img align="center" src="https://github-readme-stats.vercel.app/api?username=cs2812&show_icons=true&locale=en" alt="cs2812" /></p>
        </div>
        <div style={{padding:"1rem",boxSizing:"border-box"}}>
        <img src="https://ghchart.rshah.org/cs2812" alt="2016rshah's Blue Github Chart" />

        </div>
      </div>
    </div>
  )
}

export default Statistics
